import { Trans } from 'react-i18next';

import { ModalWidth, ShowModalEventInterceptor } from '@dreryk/react-components';

import { mfaSettingsTranslationKeys } from '../../../../../translations';

import { DeviceRemoveCellDeviceName } from './DeviceRemoveCellDeviceName';
import { DeviceRemoveIcon } from './DeviceRemoveIcon';

type TrustedDeviceRemoveCellProps = {
   readonly deviceId: number;
   readonly deviceName: string;
   readonly onRemoveSuccess: VoidFunction;
};

export const DeviceRemoveCell = (props: TrustedDeviceRemoveCellProps): JSX.Element => {
   return (
      <ShowModalEventInterceptor
         testId={'trustedDeviceRemove'}
         shouldShowModal
         title={mfaSettingsTranslationKeys.trustedDeviceTable.youAreRemovingTrustedDevice}
         confirmationButtonLabel={mfaSettingsTranslationKeys.trustedDeviceTable.remove}
         content={
            <Trans
               i18nKey={mfaSettingsTranslationKeys.trustedDeviceTable.areYouSureRemovingTrustedDevice}
               components={{ deviceName: <DeviceRemoveCellDeviceName deviceName={props.deviceName} /> }}
            />
         }
         modalWidth={ModalWidth.NORMAL}
      >
         <DeviceRemoveIcon onRemoveSuccess={props.onRemoveSuccess} deviceId={props.deviceId} />
      </ShowModalEventInterceptor>
   );
};
